/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContentItemDynamic = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m20.917 13-3.75 4.583 2.916 1.25L18 23l5-5-2.917-1.25.834-3.75z"
        fill="currentcolor"
      />
      <path
        d="M2 2v20h13v-2H4V4h16v7h2V2H2zm4 6h3V6H6v2zm5 0h7V6h-7v2zm-5 5h3v-2H6v2zm0 5h3v-2H6v2z"
        fill="currentcolor"
      />
      <path d="M18 13h-7v-2h7v2zm-3 5h-4v-2h4v2z" fill="currentcolor" />
    </g>
  </Icon>
);
export { SvgContentItemDynamic as ContentItemDynamic };
